// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe0ef6d6","239":"6472ad05","453":"12727ce6","455":"1eccea97"}[chunkId] + ".chunk.js";
};